import React from 'react';
import Box from '../Common/Box';
import {observer} from 'mobx-react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import shadowClient from "../lib/clients/shadow/shadowClient";
import {Divider, List} from "@mui/material";
import ControlButton from "../Common/ControlButton";
import RoomItem from "./RoomItem";
import {useTheme} from "@mui/material/styles";
import config from "../config";
import {createScrollbarStyle, getPanelColors} from "../lib/theme/getShadowTheme";

function RoomList() {
    const room = shadowClient.getJoinedRoom();
    const rooms = shadowClient.roomStore.rooms;
    const theme = useTheme();
    const {background: backgroundColor, color: panelColor} = getPanelColors(theme);

    return (
            <Box
                    sx={{
                        color: panelColor,
                        borderLeft: theme.palette.mode === "dark" ? "initials" : "solid 1px #d6dbe1",
                        overflow: "auto",
                        height: "100%",
                        flex: 1,
                        fontSize: "14px",
                        backgroundColor,
                        ...createScrollbarStyle(backgroundColor)
                    }}

            >

                <Box alignItems={"center"}
                     row
                     sx={{
                         display: "flex",
                         width: "100%",
                         alignItems: "center",
                         textTransform: "uppercase",
                         padding: "0px 16px",
                         height: "53px",
                         fontWeight: 800
                     }}>

                    <div style={{
                        maxWidth: "200px",
                        overflowX: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}>
                        {room?.name || "Create a room"}
                    </div>

                    <ControlButton
                            label={"Create a room"}
                            color={"red"}
                            sx={{marginLeft: "4px"}}
                            onClick={async () => {
                                const clientUser = shadowClient.getClientUser();
                                await shadowClient.leaveRoom(clientUser.room_id);
                                window.location.href = config.appUrl;
                            }}
                            icon={AddCircleOutlineIcon}
                    />

                </Box>
                <List>
                    {rooms.map((room, i) => {

                        return <React.Fragment key={room.id}>
                            <RoomItem
                                    room={room}
                            />
                            {i < rooms.length - 2 && <Divider variant="inset" component="li"/>}
                        </React.Fragment>
                    })}
                </List>

            </Box>
    );
}

export default observer(RoomList);
